import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const QualitySection = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const pointsRef = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const qualityPoints = [
    {
      title: "Uncompromising Quality",
      description:
        "Every biospecimen undergoes rigorous quality control following standardized operating procedures. Our diagnostic tests utilize state-of-the-art technology and validated methodologies. We maintain comprehensive documentation at every stage, from collection through final delivery, ensuring full traceability and reproducibility for research applications and clinical accuracy for patient testing.",
    },
    {
      title: "Ethical Foundation",
      description:
        "All biospecimens are collected through IRB-approved protocols with proper informed consent. We strictly adhere to international ethical guidelines for human specimen research including de-identification requirements and data privacy protection. Patient dignity and autonomy remain central to every aspect of our work, whether supporting research or providing diagnostic services.",
    },
    {
      title: "Commitment to Speed",
      description:
        "We understand that timing matters in research and healthcare. Our streamlined procurement processes, efficient laboratory operations, and responsive customer service ensure quick turnaround without compromising quality. From initial inquiry to final delivery, we minimize wait times while maintaining the meticulous attention to detail that research and patient care demand.",
    },
  ];

  useEffect(() => {
    const pinDuration = qualityPoints.length * 1000; // Scroll length badhane ke liye

    // Initial State: Pehle point ko chhod kar baaki sab hidden
    gsap.set(pointsRef.current.slice(1), { opacity: 0, y: 50 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top top",
        end: `+=${pinDuration}`,
        pin: true,
        scrub: 1, // Smoothness badhane ke liye scrub value (1 = 1 second delay lag)
        anticipatePin: 1,
      },
    });

    // Timeline Loop: Ek point fade out hoga, agla fade in hoga
    qualityPoints.forEach((_, i) => {
      if (i < qualityPoints.length - 1) {
        tl.to(pointsRef.current[i], { opacity: 0, y: -50, duration: 0.5 }).to(
          pointsRef.current[i + 1],
          { opacity: 1, y: 0, duration: 0.5 },
          "-=0.2",
        );
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <div
      className="flex items-center justify-center min-h-screen"
      ref={sectionRef}
    >
      <section className="w-full relative overflow-hidden bg-[#0a2571] ">
        <div className="w-full max-w-[1920px] mx-auto flex flex-col lg:flex-row min-h-[600px]">
          {/* LEFT CONTENT - Yahan text ek ke upar ek stack hai */}
          <div className="w-full lg:w-1/2 z-10 flex items-center relative px-6 lg:pl-[100px]">
            <div className="relative w-full min-h-[300px]">
              {qualityPoints.map((point, index) => (
                <div
                  key={index}
                  ref={(el) => (pointsRef.current[index] = el)}
                  className={`${
                    index === 0 ? "relative" : "absolute top-0 left-0"
                  } w-full`}
                >
                  <h3
                    className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-white leading-tight"
                    style={{ fontFamily: "Bricolage Grotesque" }}
                  >
                    {point.title}
                  </h3>
                  <p
                    className="mt-6 text-[14px] md:text-[18px] xl:text-[24px] font-light text-white/90 leading-relaxed"
                    style={{ fontFamily: "Bricolage Grotesque" }}
                  >
                    {point.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="w-full lg:w-1/2 relative h-[400px] lg:h-auto">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: "url('/images/img_image_11.png')",
              }}
            >
              {/* Desktop Gradient */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#0a2571] via-[#0a2571]/60 to-transparent hidden lg:block"></div>

              {/* Mobile Gradient */}
              <div className="absolute inset-0 bg-gradient-to-b from-[#0a2571] to-transparent lg:hidden"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QualitySection;
